import React,{ useState, useRef, useEffect } from 'react-x';
import propTypes from 'prop-types-x';
import { ccisImage } from '../../utilities/ccisImage.js';
import { CCIS_IMAGE } from '../../constants/defaults.js';

export function LazyCCISImage(props) {
  
  const { loadAndCacheAngles, altText } = props;
  const imageUtil = ccisImage(props);
  const { imgUrl, placeholderImgUrl, lazyImgPromise } = imageUtil.getLazyImgWithPlaceholderImgUrl();
  const imgUrlRef = useRef(placeholderImgUrl);
  const imgCacheRef = useRef({});
  const timerRef = useRef(false);
  const [imageUrl, setImageUrl] = useState(placeholderImgUrl);
  const cachedImgUrl = imgCacheRef.current[imgUrl];
  const imgStyle = cachedImgUrl ?  {} : { 'filter': 'blur(0.2rem)' }
  imgUrlRef.current = cachedImgUrl ? cachedImgUrl : placeholderImgUrl;

  // TODO: needs some more work to get the images to load with the best user performance.
  // Maybe load first angles on load and then lazy load the rest?
  // Will come back to this
  useEffect(() => {
    if (loadAndCacheAngles) {
      imageUtil.loadRangeOfAngles(loadAndCacheAngles).then(imgs => {
        imgs.forEach(img => {
          imgCacheRef.current[img.src] = img.src;
        })
      });
    }
  }, [imgUrl]);

  useEffect(() => {
    // Only run if image is not cached already
    if (!imgCacheRef.current[imgUrl]) {
      clearTimeout(timerRef.current);
      lazyImgPromise.then(img => {
        imgCacheRef.current[imgUrl] = img.src;
        imgUrlRef.current = img.src;
        timerRef.current = setTimeout(() => {
          setImageUrl(img.src); // trigger rerender but use ref 'imgUrlRef' for image url
        }, 50);
      }).catch(err => console.error(err));
    }

    return () => {
      clearTimeout(timerRef.current);
    }
  }, [imgUrl]);

  return (
    <img className='c-ccis-image' src={imgUrlRef.current} alt={altText} draggable='false' style={imgStyle}/>
  )
};

LazyCCISImage.propTypes = {
  token: propTypes.string.isRequired, 
  vehicle: propTypes.string.isRequired,
  angle: propTypes.number.isRequired,  
  quality: propTypes.number.isRequired,  
  type: propTypes.string.isRequired,  
  color: propTypes.string.isRequired,
  upholstery: propTypes.string,
  loadAndCacheAngles: propTypes.oneOfType([
    propTypes.string,
    propTypes.array
  ])
};

LazyCCISImage.defaultProps = {
  token: CCIS_IMAGE.token, 
  vehicle: CCIS_IMAGE.vehicle,
  angle: CCIS_IMAGE.angle,
  quality: CCIS_IMAGE.quality,
  type: CCIS_IMAGE.type,
  color: CCIS_IMAGE.color,
  upholstery: CCIS_IMAGE.upholstery
};